import { render } from "./emails-tab.vue?vue&type=template&id=5abe6989"
import script from "./emails-tab.vue?vue&type=script&lang=js"
export * from "./emails-tab.vue?vue&type=script&lang=js"

import "./emails-tab.vue?vue&type=style&index=0&id=5abe6989&lang=css"

import exportComponent from "C:\\Users\\cbetta\\Desktop\\workspace\\Developpement\\hub-web-apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__